import { Col, Form, Row, Container, Button } from "react-bootstrap";
import { Formik, Field } from "formik";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
// import { useRouter } from "next/router";
import { toast } from "react-toastify";
import { EyeFill, EyeSlashFill } from "react-bootstrap-icons";
import * as Yup from "yup";
import axios from "axios";
import { useDispatch } from "react-redux";
import { login } from "./slices/userSlice";

export default function Login({}) {
  const [show, setShow] = useState(false);
  let navigate = useNavigate();
  const dispatch = useDispatch();
  // const router = useRouter();
  const schema = Yup.object().shape({
    email: Yup.string().email("Email tidak valid").required("Wajib diisi"),
    password: Yup.string().required("Wajib diisi").min(6, "Minimal 6 karakter"),
  });
  const initialValues = {
    email: "",
    password: "",
  };
  const showPasswordHandler = () => {
    setShow(!show);
  };
  const onFormSubmit = async (data, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    const response = await axios
      .post(
        "/auth/login",
        {
          email: data.email,
          password: data.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        toast.success("Anda berhasil masuk");
        localStorage.setItem("token", response.data.access_token);
        navigate("/product", { replace: true });
        dispatch(login(response.data.user));
      })
      .catch((error) => {
        if (error.response.status === 404) {
          toast.error(error.response.data.error);
        }
      });
    setSubmitting(false);
  };
  return (
    <section className="login">
      <Container fluid className="center-login">
        <div className="form-login">
          <h2 className="h2-login">LOGIN PAGE</h2>
          <Formik
            validationSchema={schema}
            onSubmit={onFormSubmit}
            initialValues={initialValues}
          >
            {({ handleSubmit, isSubmitting, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Form.Group as={Row} controlId="formPlaintextSpesialis">
                  <Form.Label column sm="2">
                    Email:
                  </Form.Label>
                  <Col sm="8">
                    <Field
                      as={Form.Control}
                      type="text"
                      name="email"
                      placeholder="Email"
                      isInvalid={touched.email && !!errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <br />
                <Form.Group as={Row} controlId="formPlaintextSpesialis">
                  <Form.Label column sm="2">
                    Password:
                  </Form.Label>
                  <Col sm="8">
                    <Field
                      as={Form.Control}
                      type={show ? "text" : "password"}
                      name="password"
                      placeholder="Password"
                      isInvalid={touched.password && !!errors.password}
                    />
                    <div className="eye" onClick={showPasswordHandler}>
                      {show ? <EyeFill /> : <EyeSlashFill />}
                    </div>
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
                <br />
                <Button
                  className="button-login"
                  width="200px"
                  disabled={isSubmitting ? true : false}
                  type="submit"
                >
                  MASUK
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </Container>
    </section>
  );
}
